module.exports = __webpack_public_path__ + "img/bee-icon.6bb3a311.png";